import script from "./DebugSendButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugSendButtons.vue?vue&type=script&setup=true&lang=js"

import "./DebugSendButtons.vue?vue&type=style&index=0&id=882a3e26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-882a3e26"]])

export default __exports__